import api from "../services/api";
import Vue from "vue";

export default {
    namespaced: true,
    state: {
        loading: false,
        loadError: "",
        store: null,
        storeSuppliers: [],
        saving: false,
        saveError: "",
        savingCopy: false,
        saveCopyError: ""
    },
  
    getters: {
        
    },
  
    mutations: {
        setStoreSuppliers(state, data) {
            state.storeSuppliers = data;
        },
        loading(state) {
            state.loading = true;
            state.loadError = "";
        },
        loadComplete(state) {
            state.loading = false;
        },
        loadError(state, err) {
            state.storeSuppliers = [];
            state.loadError = err;
        },
        saving(state) {
            state.saving = true;
            state.saveError = "";
        },
        saveComplete(state) {
            state.saving = false;
        },
        saveError(state, err) {
            state.saveError = err;
        },
        clearSaveError(state) {
            state.saveError = "";
        },
        setSelectedStore(state, store) {
            state.store = store;
        },
        savingCopy(state) {
            state.savingCopy = true;
            state.saveCopyError = "";
        },
        saveCopyComplete(state) {
            state.savingCopy = false;
        },
        saveCopyError(state, err) {
            state.saveCopyError = err;
        },
        clearSaveCopyError(state) {
            state.saveCopyError = "";
        },
        addSupplierEntry(state, productID) {
            if (!state.storeSuppliers[productID]) {
                /**
                 * See "Change Detection Caveats": https://vuejs.org/v2/guide/reactivity.html
                 * Vue cannot detect property addition or deletion, so any computed properties
                 * that rely on state.storeSuppliers will not be automatically updated unless
                 * we use Vue.set here.
                 */
                Vue.set(state.storeSuppliers, productID, {
                    suppliers: []
                });
            }

            state.storeSuppliers[productID].suppliers.push({});
        }
    },
  
    actions: {
        addSupplierEntry(context, productID) {
            context.commit("addSupplierEntry", productID)
        },
        setSelectedStore(context, store) {
            context.commit("setSelectedStore", store);
        },
        clearSaveError(context) {
            context.commit("clearSaveError");
        },
        clearSaveCopyError(context) {
            context.commit("clearSaveCopyError");
        },
        saveCopy(context, options) {
            context.commit("savingCopy");

            api.copyStoreSupplier(
                options.data,
                {
                    success: function(response) {
                        // the response we get back from this function is the list of items (which will include the changes we requested)
                        let supplierData = response.data;
                        if(options.formatSupplierData == true){
                            supplierData = formatSupplierData(response.data);
                        }

                        context.commit("setStoreSuppliers", supplierData);

                        if (options.success) {
                            options.success(supplierData);
                        }
                    },
                    error: function(e) {
                        context.commit("saveCopyError", api.parseHttpRequestError(e));

                        if (options.error) {
                            options.error(e);
                        }
                    },
                    finally: function() {
                        context.commit("saveCopyComplete");

                        if (options.finally) {
                            options.finally();
                        }
                    }
                }
            );
        },
        saveStoreSuppliers(context, options) {
            context.commit("saving");

            api.saveStoreSuppliers(
                {
                    storeID: context.state.store.ID,
                    data: context.state.storeSuppliers
                },
                {
                    success: function(response) {
                        // the response we get back from this function is the list of items (which will include the changes we requested)
                        let supplierData = response.data;
                        if(options.formatSupplierData == true){
                            supplierData = formatSupplierData(response.data);
                        }

                        context.commit("setStoreSuppliers", supplierData);

                        if (options.success) {
                            options.success(supplierData);
                        }
                    },
                    error: function(e) {
                        context.commit("saveError", api.parseHttpRequestError(e));

                        if (options.error) {
                            options.error(e);
                        }
                    },
                    finally: function() {
                        context.commit("saveComplete");

                        if (options.finally) {
                            options.finally();
                        }
                    }
                }
            );
        },
        loadStoreSuppliers(context, options) {
            return new Promise((resolve, reject) => {
                context.commit("loading");

                api.fetchStoreSuppliers({
                    storeID: options.storeID,
                    success: function(response) {
                        let supplierData = response.data;
                        if(options.formatSupplierData == true){
                            supplierData = formatSupplierData(response.data);
                        }

                        context.commit("setStoreSuppliers", supplierData);

                        if (options.success) {
                            options.success(supplierData);
                        }

                        resolve();
                    },
                    error: function(e) {
                        context.commit("loadError", api.parseHttpRequestError(e));

                        if (options.error) {
                            options.error(e);
                        }

                        reject(api.parseHttpRequestError(e));
                    },
                    finally: function() {
                        context.commit("loadComplete");

                        if (options.finally) {
                            options.finally();
                        }
                    }
                });
            });
        }
    }
}

function formatSupplierData(storeSuppliers) {
    // we need to conver the data into the format we are going to use
    let formattedData = {};

    for (let i=0; i<storeSuppliers.length; i++) {
        let entry = storeSuppliers[i];

        if (!formattedData.hasOwnProperty(entry.ProductID)) {
            formattedData[entry.ProductID] = {
                ProductName: entry.ProductName,
                suppliers: []
            };
        }

        formattedData[entry.ProductID].suppliers.push({
            SupplierID: entry.SupplierID,
            SupplierName: entry.SupplierName,
            Quantity: entry.Quantity
        });
    }

    return formattedData;
}